import React, { useState } from 'react'
import { isMobile } from 'react-device-detect'
import { Trans, useTranslation } from 'react-i18next'

import bagsImage from 'assets/landing-images/bags.png'
import bagsImageMobile from 'assets/landing-images/bags2.png'
import coinsImage from 'assets/landing-images/coins.png'
import coinsImageMobile from 'assets/landing-images/coins2.png'
import crabImage from 'assets/landing-images/crab.png'
import homerImage from 'assets/landing-images/homer.png'

import { Button } from '../'
import * as S from './styleds'
import { useMoveByMouse } from './useMoveByMouse'

export const Main = () => {
  const [coinsNode, setCoinsNode] = useState<null | HTMLImageElement>(null)
  const [bagsNode, setBagsNode] = useState<null | HTMLImageElement>(null)

  const { t } = useTranslation()

  useMoveByMouse(coinsNode)
  useMoveByMouse(bagsNode)

  return (
    <S.Root>
      <S.Title>
        <Trans i18nKey="Trade and earn">
          <S.TitleWordWithImage>
            <S.TitleHomer src={homerImage} />
            <S.TitleWordDecorated>Trade</S.TitleWordDecorated>
            <S.TitleCoins src={isMobile ? coinsImageMobile : coinsImage} ref={node => setCoinsNode(node)} />
          </S.TitleWordWithImage>
          and
          <S.TitleWordWithImage isByRight>
            <S.TitleCrab src={crabImage} />
            <S.TitleWordDecorated>earn</S.TitleWordDecorated>
            <S.TitleBags src={isMobile ? bagsImageMobile : bagsImage} ref={node => setBagsNode(node)} />
          </S.TitleWordWithImage>
        </Trans>
        <br />
        <Trans i18nKey="200+ tokens at the best rates">
          <S.TitleTextColored>200+</S.TitleTextColored> tokens at the best rates
        </Trans>
      </S.Title>
      <S.Text>{t('WOWswap is a decentralized leveraged trading protocol')}</S.Text>
      <S.Buttons>
        <Button color="red" icon="swap" routeTo="/swap">
          {isMobile ? t('Swap') : t('Swap Now')}
        </Button>
        <Button color="green" icon="bag" routeTo="/earn">
          {isMobile ? t('Earn') : t('Start Earning')}
        </Button>
      </S.Buttons>
    </S.Root>
  )
}
